import { call, put, takeEvery } from "redux-saga/effects";
import { FETCHING_PREFERENCES_SKILLS_FAILED, FETCH_PREFERENCES_SKILLS_REQUEST, FETCHING_PREFERENCES_SKILLS_SUCCEEDED, FETCHING_SKILLS_FAILED, FETCHING_SKILLS_REQUEST, FETCHING_SKILLS_SUCCEEDED, INVALIDATE_SKILLS, SEARCHING_SKILLS_FAILED, SEARCHING_SKILLS_REQUEST, SEARCHING_SKILLS_SUCCEEDED, UPDATE_SKILLS_PREFERENCES_REQUEST, UPDATE_SKILLS_REQUEST, UPDATING_SKILLS_FAILED, UPDATING_SKILLS_PREFERENCES_SUCCEEDED } from "../actionTypes";
import { createAction } from "@reduxjs/toolkit";
import { FetchPreferencesSkillErrorResponse, FetchPreferencesSkillResponse, FetchSkillsErrorResponse, FetchSkillsRequest, FetchSkillsResponse, SearchSkillsErrorResponse, SearchSkillsRequest, SearchSkillsResponse, UpdateSkillsErrorResponse, UpdateSkillsRequest, UpdateSkillsResponse } from "src/types/coaching/skills";
import axios from "axios";
import buildUrl from "build-url-ts";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

//Fetch Skills
export const fetchSkills = createAction<FetchSkillsRequest>(FETCHING_SKILLS_REQUEST);
const fetchingSkillsSucceeded = createAction<FetchSkillsResponse>(FETCHING_SKILLS_SUCCEEDED);
const fetchingSkillsFailed = createAction<FetchSkillsErrorResponse>(FETCHING_SKILLS_FAILED);

const fetchSkillsSaga = function* (action: ReturnType<typeof fetchSkills>): any {
  const {query, parent, page, limit} = action.payload as FetchSkillsRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/skills`,
    queryParams: {
      query: query,
      parent: parent,
      page: page,
      limit: limit,
    }
  });
 
  const fetchSkillsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSkillsAPI);
    yield put(fetchingSkillsSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingSkillsFailed({error: error }));
  }
};

//search skills
export const searchSkills = createAction<SearchSkillsRequest>(SEARCHING_SKILLS_REQUEST);
const searchingSkills = createAction<SearchSkillsResponse>(SEARCHING_SKILLS_SUCCEEDED);
const searchingSkillsFailed = createAction<SearchSkillsErrorResponse>(SEARCHING_SKILLS_FAILED);

const searchSkillsSaga = function* (action: ReturnType<typeof searchSkills>): any {

  const {query, parent, page, limit} = action.payload as SearchSkillsRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/skills`,
    queryParams: {
      query: query,
      parent: parent,
      page: page,
      limit: limit,
    }
  });

  const searchSkillsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(searchSkillsAPI);
    yield put(searchingSkills({
      response: response
    }));

  } catch (error) {
    yield put(searchingSkillsFailed({error: error }));
  }
}

export const updateSkillsPreference = createAction<UpdateSkillsRequest>(UPDATE_SKILLS_PREFERENCES_REQUEST);
const updatingSkillsPreferenceSucceeded = createAction<UpdateSkillsResponse>(UPDATING_SKILLS_PREFERENCES_SUCCEEDED);
const updatingSkillsPreferenceFailed = createAction<UpdateSkillsErrorResponse>(UPDATING_SKILLS_FAILED);

const updateSkillsSaga = function* (action: ReturnType<typeof updateSkillsPreference>): any {
  const { skills } = action.payload as UpdateSkillsRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/explore/skill_preferences`,

  });
 
  const updateSkillsAPI = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: skills,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateSkillsAPI);
    yield put(updatingSkillsPreferenceSucceeded({skills: skills}));
  } catch (error) {
    yield put(updatingSkillsPreferenceFailed({error: error }));
  }
};

export const invalidateSkills = createAction<void>(INVALIDATE_SKILLS);


export default function* skillsSagas () {
  yield takeEvery(FETCHING_SKILLS_REQUEST, fetchSkillsSaga);
  yield takeEvery(SEARCHING_SKILLS_REQUEST, searchSkillsSaga);
  yield takeEvery(UPDATE_SKILLS_PREFERENCES_REQUEST, updateSkillsSaga);
}